import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, gradient, colors } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  width: "100%",
  flexShrink: 0,
  backgroundColor: greys.white,
  position: "relative", // make sure content can absolutely position itself, if need be
};

export const containerWithBorder: CSSProperties = {
  ...container,
  borderBottom: `1px solid ${greys.cloudyBlue}`,
};

export const gradientBar: CSSProperties = {
  height: 4,
  width: "100%",
  flexShrink: 0,
  background: gradient,
};

export const menuIcon = {
  color: greys.slate,
  "&:hover": {
    color: greys.standard,
  },
} as CSSProperties;

export const divider: CSSProperties = {
  marginTop: 0,
  marginBottom: 0,
};

export const styles = {
  menuIcon,
};

const badge: CSSProperties = {
  top: 9,
  right: -15,
  background: colors.peach.darker,
};

export const chromeNavTabsStyles = {
  badge,
};
